import Axios from 'axios';
import Qs from 'qs';

export default {

  // 版块分页列表
  listPage(
    name,
    status,
    community_ids,
    page,
    per_page
  ) {
    return Axios.get('/llhd/api/admin/categories', {
      params: {
        name,
        status,
        community_ids,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 版块列表
  list(
    filter = 'enable'
  ) {
    return Axios.get('/llhd/api/admin/categories/all', {
      params: {
        filter
      }
    });
  },

  // 版块添加
  add(
    name
  ) {
    return Axios.post('/llhd/api/admin/categories', {
      name,
      status: 1
    });
  },

  // 版块编辑
  edit(
    id,
    name,
    status
  ) {
    return Axios.put(`/llhd/api/admin/categories/${id}`, {
      name,
      status
    });
  },

  // 版块删除
  del(
    ids
  ) {
    return Axios.delete('/llhd/api/admin/categories', {
      data: {
        ids
      }
    });
  },

  // 版块详情
  info(
    id
  ) {
    return Axios.get(`/llhd/api/admin/categories/${id}`);
  },

  // 版块启用
  enable(
    id
  ) {
    return Axios.post(`/llhd/api/admin/categories/${id}/status`, {
      status: 1
    })
  },

  // 版块禁用
  disable(
    id
  ) {
    return Axios.post(`/llhd/api/admin/categories/${id}/status`, {
      status: 0
    })
  }

}